import React from "react";
import "./CV.scss";

function CV(props) {
  return (
    <div className="cv-container">
      <div className="cv-column">
        <h3>Cv Page Works</h3>
        <div>
          <p className="chapter-title"><b>INFORMATION</b></p>
          <p>www.miltostsakirisportfolio.web.app</p>
          <p>miltostsalekkas@gmail.com</p>
          <p>Kingsland Road, E84AR</p>
          <p>Architect</p>
          <p>University of Thessaly</p>
          <p>Age : 26</p>
          <p>Diploma GPO : 9,02 /10</p>
        </div>
      </div>
      <div className="cv-column">
        <h3>Cv Page Works</h3>
      </div>
    </div>
  );
}

export default CV;
